import React, { useState, useEffect } from 'react';
import { salesApi } from '../../api';
import { PageHeader, StatCard } from '../../components/common';

const SalesDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await salesApi.getStatistics();
        setStats(res.data);
      } catch (err) {
        console.error('Failed to fetch stats:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  return (
    <div>
      <PageHeader title="销售仪表盘" />

      <h3 style={{ marginBottom: '15px' }}>我的业绩</h3>
      <div className="stats-grid">
        <StatCard title="总销售记录" value={stats?.total || 0} color="#1890ff" />
        <StatCard title="已发号" value={stats?.delivered || 0} color="#52c41a" />
        <StatCard title="已结算" value={stats?.settled || 0} color="#722ed1" />
        <StatCard title="待绑定" value={stats?.pending || 0} color="#faad14" />
      </div>

      <h3 style={{ marginBottom: '15px' }}>金额统计</h3>
      <div className="stats-grid">
        <StatCard title="总金额" value={`¥${(stats?.total_amount || 0).toFixed(2)}`} color="#1890ff" />
        <StatCard title="已结算金额" value={`¥${(stats?.settled_amount || 0).toFixed(2)}`} color="#52c41a" />
      </div>
    </div>
  );
};

export default SalesDashboard;
